import React, { useEffect } from 'react';
import { FormValidator } from '../../form/controls/input';
import { FramedContent } from '../../framed-content';
import { FormSharepoint } from '../../form/compositions/FormSharepoint';
import { useSelector } from 'react-redux';

interface ICreateSharepointForm {
  props: any;
}

const CreateSharepointForm: React.FC<ICreateSharepointForm> = ({ props }) => {
  const parentId = useSelector(state => state.detail?.item?._id);
  const parentType = useSelector(state => state.detail?.item?.type);
  if (
    !props.flowData?.itemData?.termsAccepted
      || !FormValidator.isValid('', 'sharepoint')) {
    props.setNextStepDisabled(true);
  } else {
    props.setNextStepDisabled(false);
  }
  let subtitle =
    'Welche Quelle / Dienst / Plattform wollen Sie mit anderen Teilnehmern der Gruppe teilen? Bitte geben Sie Ihrem Sharepoint einen aussagekräftigen Titel und ergänzen Sie eine kurze Beschreibung/Agenda. Beides ist für die Gruppenmitglieder sichtbar.';
  useEffect(() => {
    props.flowFunctions.setFlowData({ ...props.flowData, parentType, parentId });
  }, [parentId, parentType]);
  return (
    <FramedContent>
      <FormSharepoint
        formData={props.flowData}
        headline={'Sharepoint erstellen'}
        subtitle={subtitle}
        onChange={(formField, formValue) => {
          props.flowFunctions.setFlowFormData(formField, formValue);
        }}
      />
    </FramedContent>
  );
};

export const ConnectedCreateSharepointForm = (props: any) => {
  return <CreateSharepointForm props={{ ...props }} />;
};
